import { mapGetters, mapActions } from 'vuex'
import { listCarriers } from 'src/stubs/carriers'
import { convertToSlugArray } from 'src/filters'
import { uniq, isEmpty } from 'lodash'

export default {
  data () {
    let validatorRegion = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error('Vùng miền không được để trống'))
      } else {
        callback()
      }
    }
    return {
      localCity: {
        name: '',
        allow: false,
        short_name: '',
        region_id: 0,
        code: '',
        regions: []
      },
      rules: {
        name: [
          {required: true, message: 'Bạn chưa nhập tên tỉnh thành', trigger: 'change'},
          {min: 5, max: 255, message: 'Tên tỉnh thành phải trong khoảng 5 đến 255 ký tự', trigger: 'change'}
        ],
        short_name: [
          {required: true, message: 'Bạn chưa nhập tên viết tắt', trigger: 'change'},
          {min: 2, max: 255, message: 'Tên tỉnh thành viết tắt phải trong khoảng 2 đến 255 ký tự', trigger: 'change'}
        ],
        region_id: [
          {required: true, validator: validatorRegion, trigger: 'change'}
        ],
        code: [
          {required: true, message: 'Bạn chưa nhập mã bưu chính ', trigger: 'change'},
          {min: 1, max: 255, message: 'Mã bưu chính  phải trong khoảng 1 đến 255 ký tự', trigger: 'change'}
        ]
      },
      listCarriers: listCarriers,
      submitting: false,
      mapNames: [],
      options: [],
      isUpdating: false,
    }
  },
  computed: {
    ...mapGetters('region', ['regions'])
  },
  methods: {
    ...mapActions('region', ['getAllRegion']),
    newCity () {
      this.localCity = {
        name: '',
        short_name: '',
        allow: false,
        region_id: 0,
        code: '',
        regions: []
      }
    },
    handleChange(newValue) {
      if (this.isUpdating) return
      const latestValue = newValue[newValue.length - 1] // Lấy giá trị mới nhất
      // Kiểm tra giá trị rỗng hoặc chỉ chứa khoảng trắng
      if (!latestValue) return
      if (isEmpty(latestValue) || !/[a-zA-Z0-9]/.test(latestValue)) {
        this.isUpdating = true
        // Loại bỏ giá trị không hợp lệ và cập nhật sau khi DOM đã render
        this.mapNames = newValue.slice(0, -1) // Lấy tất cả phần tử trừ phần tử cuối
        this.$nextTick(() => {
          this.isUpdating = false
        })
        return
      }
      const isNew = !this.options.some((opt) => opt.value === latestValue.trim())
      if (isNew) {
        this.isUpdating = true
        const slugValue = convertToSlugArray(latestValue) // Chuyển đổi giá trị mới thành slug
        // Thay thế giá trị mới bằng slug trong mảng
        this.mapNames.splice(newValue.length - 1, 1, slugValue)
        this.mapNames = uniq(this.mapNames)
        // Thêm cả giá trị gốc và slug vào options
        this.$nextTick(() => {
          this.isUpdating = false // Tắt flag sau khi cập nhật xong
        })
      }
    },
  },
  mounted () {
    this.newCity()
    if (!this.regions.length) {
      this.getAllRegion({params: {limit: -1}})
    }
  },
  watch: {
    localCity: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/city/mixins/index.js